class window.CapEditor
    self = undefined

    constructor: (territories, capitals) ->
        self = this

        @territories = territories
        @capitals = capitals

        @selectedPlayer = 0
        @pickerEnabled = false

        # Select players
        $("#num-player-links [data-players]").click(() ->
            self.activatePlayers($(this).data('players'))
            return false
        )

        # Update textbox on blur or if enter is pressed.
        $("#capital-inputs textarea").blur(() ->
            self.validateCapitals($(this).data('players'))
            return true
        ).keydown((e) ->
            if e.keyCode is 13
                self.validateCapitals($(this).data('players'))
            return true
        )
        $('#picker-toggle').click(() ->
            self.togglePicker()
            return false
        )
        $('[data-territory]').click(() ->
            if self.pickerEnabled
                if $(this).parent().is('.capital')
                    self.unpickTerritory($(this).data('territory'))
                else
                    self.pickTerritory($(this).data('territory'))
            return false
        )

        @activatePlayers(2)
        for i in [3..9]
            @validateCapitals(i, true)

    activatePlayers: (numPlayers) ->
        @selectedPlayer = numPlayers

        # Remove selected arrow.
        $('#num-player-links [data-players] > .fa').removeClass('fa-caret-right')
        # Add arrow to right number of players.
        row = $("#num-player-links [data-players=#{numPlayers}] > .fa").addClass('fa-caret-right')

        # Remove textboxes.
        $('#capital-inputs textarea').css('display', 'none')
        # Show right textbox.
        $("#capital-inputs textarea[data-players=#{numPlayers}]").css('display', 'inline-block')

        # Reset status.
        $('#validate-status').removeClass('success warning error')
        $('#validate-status').html('')

        @validateCapitals(numPlayers)

    updateCapitals: (numPlayers) ->
        # Remove all capital circles.
        $('[data-territory]').parent('.capital').removeClass('capital')
        # Add the capital circles for the right number of players.
        if @capitals[numPlayers]?
            for t in @capitals[numPlayers]
                $("[data-territory=#{t.territory_id}]").parent().addClass('capital')

    validateCapitals: (numPlayers, inBackground = false) ->
        if not inBackground
            $('#validate-status')
                .removeClass('success warning error')
                .html('<i class="fa fa-spinner fa-pulse"></i>')

        textarea = $("#capital-inputs textarea[data-players=#{numPlayers}]")
        textarea.parent().removeClass('form-success form-warning form-error')

        inputCaps = textarea.val().trim().split("\n")

        if inputCaps.length is 1 and inputCaps[0] is ''
            textarea.parent().addClass('form-warning')
            @setValidationMessage(numPlayers, 'warning', 'No territories specified', inBackground)

            if not inBackground
                @updateCapitals(numPlayers)
            return

        errors = []

        @capitals[numPlayers] = []

        for t in inputCaps
            if @territories[t]?
                @capitals[numPlayers].push(@territories[t])
            else
                errors.push(t)

        if errors.length > 0
            textarea.parent().addClass('form-error')

            msg = 'The following territories are not valid:<br>'
            for t in errors
                msg += t + '<br>'

            @setValidationMessage(numPlayers, 'error', msg, inBackground)

        else if @capitals[numPlayers].length isnt numPlayers
            textarea.parent().addClass('form-warning')
            @setValidationMessage(numPlayers, 'warning', 'Wrong number of territories.', inBackground)

        else
            textarea.parent().addClass('form-success')
            @setValidationMessage(numPlayers, 'success', '*insert confetti*', inBackground)

        if not inBackground
            @updateCapitals(numPlayers)

    setValidationMessage: (numPlayers, status, message, inBackground) ->
        span = $("#validate-status-#{numPlayers}")

        span.removeClass('success warning error')
            .addClass(status)

        span.find('.fa')
            .removeClass('fa-question-circle fa-check fa-warning fa-times')
            .addClass(
                switch status
                    when 'success' then 'fa-check'
                    when 'warning' then 'fa-warning'
                    when 'error' then 'fa-times'
                    else 'fa-question-circle'
            )

        span.find('.tt-inner')
            .html(message)

        if not inBackground
            if status is 'success'
                $('#validate-status').html('')
            else
                $('#validate-status').addClass(status).html(message)

    togglePicker: () ->
        @pickerEnabled = not @pickerEnabled

        if @pickerEnabled
            $('#map').css('cursor', 'crosshair')
            $('[data-territory]').html('+')
            $('#picker-toggle').html('<i class="fa fa-crosshairs"></i> Disable picker')
        else
            $('#map').css('cursor', 'default')
            $('[data-territory]').html('')
            $('#picker-toggle').html('<i class="fa fa-crosshairs"></i> Enable picker')

    pickTerritory: (terrID) ->
        # Find the right territory.
        for name, t of @territories
            if t.territory_id is terrID
                terr = name
                break

        # Shouldn't happen, but let's still check.
        if not terr?
            messageDisplay.error('Could not find territory')
            return

        appends = if $("#capital-inputs textarea[data-players=#{@selectedPlayer}]").val() is ''
            name
        else
            "\n" + name

        $("#capital-inputs textarea[data-players=#{@selectedPlayer}]").append(appends)

        @validateCapitals(@selectedPlayer)

    unpickTerritory: (terrID) ->
        @capitals[@selectedPlayer] = @capitals[@selectedPlayer].filter((t) -> t.territory_id isnt terrID)
        $("#capital-inputs textarea[data-players=#{@selectedPlayer}]").html(
            @capitals[@selectedPlayer].map((t) -> t.name).join("\n")
        )
        @validateCapitals(@selectedPlayer)
